import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const CalendarCheck = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <defs>
          <clipPath id="calendarCheck__a">
            <rect
              x="0"
              y="0"
              width="16"
              height="16"
              rx="0"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#calendarCheck__a)">
          <path
            d="M13,2L11.5,2L11.5,1.5C11.5,1.36739004,11.4473,1.24021494,11.35355,1.14644504C11.2598,1.052680016,11.1325998,1,11,1C10.8674002,1,10.7402,1.052680016,10.64645,1.14644504C10.5527,1.24021494,10.5,1.36739004,10.5,1.5L10.5,2L5.5,2L5.5,1.5C5.5,1.36739004,5.4473,1.24021494,5.35355,1.14644504C5.2598,1.052680016,5.1325997999999995,1,5,1C4.8673902,1,4.7402148,1.052680016,4.646444799999999,1.14644504C4.5526800000000005,1.24021494,4.5,1.36739004,4.5,1.5L4.5,2L3,2C2.73478508,2,2.48042989,2.1053550000000003,2.29289508,2.2928951C2.10535502,2.4804299,2,2.7347851,2,3L2,13C2,13.2652,2.10535502,13.51955,2.29289508,13.7071C2.48042989,13.89465,2.73478508,14,3,14L13,14C13.2652,14,13.51955,13.89465,13.7071,13.7071C13.89465,13.51955,14,13.2652,14,13L14,3C14,2.7347851,13.89465,2.4804299,13.7071,2.2928951C13.51955,2.1053550000000003,13.2652,2,13,2ZM10.6037502,8.3537502L7.6037502,11.35375C7.5573001,11.40025,7.5021501,11.4371,7.4414501,11.4623C7.3807502,11.48745,7.3157001,11.5004,7.25,11.5004C7.1842999,11.5004,7.1192498,11.48745,7.0585499,11.4623C6.9978499,11.4371,6.9426999,11.40025,6.8962498,11.35375L5.3962498,9.8537502C5.3024502,9.7599497,5.2497001,9.6327,5.2497001,9.5C5.2497001,9.3673,5.3024502,9.2400503,5.3962498,9.1462498C5.4900497999999995,9.0524502,5.6173,8.9996996,5.75,8.9996996C5.8827,8.9996996,6.0099502,9.0524502,6.1037502,9.1462498L7.25,10.2931499L9.8962498,7.6462498C9.9427004,7.5998001,9.9978504,7.5629501,10.0585499,7.5377998C10.1192503,7.51265,10.1843004,7.4997001,10.25,7.4997001C10.3156996,7.4997001,10.3807497,7.51265,10.4414501,7.5377998C10.5021496,7.5629501,10.5572996,7.5998001,10.6037502,7.6462498C10.6501999,7.6926999,10.6870499,7.7478499,10.7122002,7.8085499C10.7373505,7.8692498,10.7503004,7.9342999,10.7503004,8C10.7503004,8.0656996,10.7373505,8.130749699999999,10.7122002,8.1914501C10.6870499,8.2521496,10.6501999,8.3072996,10.6037502,8.3537502ZM3,5L3,3L4.5,3L4.5,3.5C4.5,3.6326101,4.5526800000000005,3.7597849,4.646444799999999,3.853555C4.7402148,3.94732,4.8673902,4,5,4C5.1325997999999995,4,5.2598,3.94732,5.35355,3.853555C5.4473,3.7597849,5.5,3.6326101,5.5,3.5L5.5,3L10.5,3L10.5,3.5C10.5,3.6326101,10.5527,3.7597849,10.64645,3.853555C10.7402,3.94732,10.8674002,4,11,4C11.1325998,4,11.2598,3.94732,11.35355,3.853555C11.4473,3.7597849,11.5,3.6326101,11.5,3.5L11.5,3L13,3L13,5L3,5Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
